import type { AppliedPromoCode } from './reservation/types.ts';
import { useSettings } from './use-settings.tsx';

export function toSar(amount: number) {
  return (amount / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: 'SAR',
  });
}

function toSarShort(amount: number) {
  return (amount / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function lineFor(amount: number) {
  return {
    value: amount,
    label: toSar(amount),
    shortLabel: toSarShort(amount),
  };
}

export function usePaymentInfo(params: {
  kind: 'standard' | 'second_opinion';
  urgent?: boolean;
  appliedPromo?: AppliedPromoCode;
}) {
  const settings = useSettings();
  let totalAmount = 0;
  if (params.kind === 'second_opinion') {
    if (params.urgent) {
      totalAmount = Number(settings?.secondOpinionUrgentFee?.value || 0);
    } else if (settings?.secondOpinionFee) {
      totalAmount = Number(settings?.secondOpinionFee?.value || 0);
    }
  } else {
    totalAmount = Number(settings?.appointmentFee?.value || 0);
  }

  const promoDiscount = params.appliedPromo?.discountHalalas ?? 0;
  const amountDue = totalAmount - promoDiscount;

  return {
    total: lineFor(totalAmount),
    insuranceDiscount: lineFor(0),
    promoDiscount: lineFor(promoDiscount),
    vat: lineFor(0),
    amountDue: lineFor(amountDue),
    appliedPromoCode: params.appliedPromo?.code,
  };
}

export type PaymentInfo = ReturnType<typeof usePaymentInfo>;
